// eslint-disable-next-line
// @ts-nocheck

export const ConvertMouseToTouch = {
  install() {
    const defaultCustomTouch = {
      clientX: 0,
      clientY: 0,
      identifier: 0,
      pageX: 0,
      pageY: 0,
      screenX: 0,
      screenY: 0,
      target: 0,
    };

    class CustomTouch extends (typeof Touch !== 'undefined' ? Touch : Object) {
      constructor(touchInit) {
        super(touchInit);

        if (typeof Touch === 'undefined') {
          Object.assign(this, defaultCustomTouch, touchInit);
        }
      }
    }

    const defaultCustomTouchEvent = {
      view: null,
      changedTouches: null,
      targetTouches: null,
      touches: null,
    };

    class CustomTouchEvent extends (typeof TouchEvent !== 'undefined' ? TouchEvent : Event) {
      constructor(typeArg, eventInit) {
        super(typeArg, eventInit);

        if (typeof TouchEvent === 'undefined') {
          Object.assign(this, defaultCustomTouchEvent, {
            view: eventInit.view,
            changedTouches: eventInit.changedTouches,
            targetTouches: eventInit.targetTouches,
            touches: eventInit.touches,
          });
        }

        // bugfix: In mac catalyst, event.timeStamp may be 0
        Object.defineProperty(this, 'timeStamp', {
          value: Date.now(),
        });
      }
    }

    const createTouchList = function (touchs) {
      Object.defineProperty(touchs, 'item', {
        get() {
          return function (index) {
            return this[index];
          };
        },
      });

      return touchs;
    };

    const convertMouseEvent2TouchEvent = function (mouseEvent, type) {
      const touch = new CustomTouch({
        identifier: 0,
        target: mouseEvent.target,
        clientX: mouseEvent.clientX,
        clientY: mouseEvent.clientY,
        pageX: mouseEvent.pageX,
        pageY: mouseEvent.pageY,
        screenX: mouseEvent.screenX,
        screenY: mouseEvent.screenY,
      });

      const touchList = createTouchList([touch]);

      const touchEvent = new CustomTouchEvent(type, {
        bubbles: mouseEvent.bubbles,
        cancelable: mouseEvent.cancelable,
        composed: mouseEvent.composed,
        ctrlKey: mouseEvent.ctrlKey,
        shiftKey: mouseEvent.shiftKey,
        altKey: mouseEvent.altKey,
        metaKey: mouseEvent.metaKey,
        view: mouseEvent.view,
        touches: touchList,
        targetTouches: touchList,
        changedTouches: touchList,
      });

      return touchEvent;
    };

    const init = function () {
      let hasCaptureByTouch = false;
      let hasMouseDown = false;

      window.addEventListener(
        'touchstart',
        (event) => {
          if (!event.isTrusted) {
            return;
          }
          hasCaptureByTouch = true;
        },
        {
          capture: true,
          passive: false,
        },
      );

      let touchTarget = null;

      window.addEventListener(
        'mousedown',
        (event) => {
          if (hasCaptureByTouch) {
            return;
          }
          hasCaptureByTouch = false;
          hasMouseDown = true;

          if (!touchTarget) {
            touchTarget = event.target;
          }

          touchTarget.dispatchEvent(convertMouseEvent2TouchEvent(event, 'touchstart') as Event);
        },
        {
          capture: true,
          passive: false,
        },
      );
      window.addEventListener(
        'mousemove',
        (event) => {
          if (hasCaptureByTouch || !hasMouseDown) {
            return;
          }

          if (touchTarget) {
            touchTarget.dispatchEvent(convertMouseEvent2TouchEvent(event, 'touchmove') as Event);
          }
        },
        {
          capture: true,
          passive: false,
        },
      );

      window.addEventListener(
        'mouseup',
        (event) => {
          if (hasCaptureByTouch || !hasMouseDown) {
            return;
          }

          hasMouseDown = false;
          touchTarget.dispatchEvent(convertMouseEvent2TouchEvent(event, 'touchend') as Event);

          touchTarget = null;
        },
        {
          capture: true,
          passive: false,
        },
      );
    };

    init();
  },
};
